import React, { useEffect } from 'react'
import Portal from './portal'
import Cross from '../../icons/cross'

export default function Popup({children,setOpen,open,gradient}) {
    useEffect(() =>{
        if(open){
            document.querySelector('body').style.height = '100vh';
            document.querySelector('body').style.overflow = 'hidden';
        }else{
            document.querySelector('body').style.height = 'unset';
            document.querySelector('body').style.overflow = 'unset';
        }
    },[open])
    return (
        <Portal>
            <div className={'popup ' + (open ? 'open' : '')}>
                <button aria-label='button' onClick={() => setOpen('')} className={'overlay ' + (open ? 'open' : '')} ></button>
                <div className='popup-content left-gradient-image'  style={{ backgroundImage: `url(${gradient?.url})` }}>

                    <button onClick={() => setOpen('')} className='close'>
                        <Cross />
                    </button>

                  {children}
                </div>
            </div>
        </Portal>
    )
}
